<template>
  <div class="chat_mask1">
    <div class="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="chat-wrapper">
        <div class="chat_close_btn" @click="closeChat">关闭</div>
        <el-row>
          <div class="current-conversation-wrapper">
            <div class="current-conversation"  >
              <div class="header">
                <div class="name">莲藕互联网医院</div>
                <div class="flex2 inquiry_status_1">
                  <div class="flex2">
                    <img src="@/img/select_1.png" style="width:18px;height:18px" />
                    <div style="flex:0 0 auto">提交问诊</div>
                  </div>
                  <div style="width:30%;height:2px;background:#8a8a8a;margin:0 5px"></div>
                  <div class="flex2">
                    <img src="@/img/select_1.png" style="width:18px;height:18px" />
                    <div style="flex:0 0 auto">医师问诊</div>
                  </div>

                  <div style="width:30%;height:2px;background:#8a8a8a;margin:0 5px"></div>
                  <div class="flex2" v-if="$store.state.inquiryStatus==5">
                    <img src="@/img/select_3.png" style="width:18px;height:18px" />
                    <div style="flex:0 0 auto">已开方</div>
                  </div>
                  <div class="flex2" v-if="$store.state.inquiryStatus==99">
                    <!-- <img src="@/img/close_5.png" style="width:30px;height:30px" /> -->
                    <div style="flex:0 0 auto;color:red">拒绝开方</div>
                  </div>
                </div>
              </div>

              <div class="content">
                <div class="message-list" ref="message-list" >
                  <message-item
                    v-for="message in currentMessageList"
                    :key="message.MsgRandom"
                    :message="message"
                  />
                </div>
              </div>
              <!-- <div class="footer" >
                <message-send-box />
                <div class="end_mask" v-if="true">问诊已经结束</div>
              </div> -->
            </div>
          </div>
        </el-row>
      </div>
      <image-previewer />
    </div>
  </div>
</template>

<script>
import { Notification } from "element-ui";
import { GetGroupMsg } from "@/utils/api";
import CurrentConversation from "@/components/conversation/current-conversation";
import ImagePreviewer from "@/components/message/image-previewer.vue";
import messageItem from "@/components/message/message-item-his";
import MessageSendBox from "@/components/message/message-send-box";

import ConversationProfile from "@/components/conversation/conversation-profile.vue";
export default {
  title: "TIMSDK DEMO",
  props:{
    inquiryId:{
      type:String,
      default:""
    }
  },
  components: {
    CurrentConversation,
    ImagePreviewer,
    MessageSendBox,
    messageItem,
    ConversationProfile
  },
  data() {
    return {
      currentMessageList: []
    };
  },
  methods: {
      closeChat(){
        this.$store.commit("changeHisChat",false)
      },
 

    getList() {
    let that = this
      let data = {
        inquiryId: this.inquiryId,
        token:localStorage.getItem("hToken"),
        method: "4"
      };
      GetGroupMsg(data).then(res => {
        if(res.data==null){
        this.$Message.error(
          "暂无问诊记录"
        );
          this.$store.commit("changeHisChat",false)
          return
        }
        console.info("历史聊天记录：", JSON.parse(res.data));
        let datas = JSON.parse(res.data);
        let userId = localStorage.getItem("app_mobile");
            datas.map(item=>{
              item.type =item.MsgBody[0].MsgType
              item.conversationID = 1
              item.payload = item.MsgBody[0].MsgType
              var text = item.MsgBody[0].MsgContent.Text;
              var data = item.MsgBody[0].MsgContent.Data;
              var Desc = item.MsgBody[0].MsgContent.Desc;
              var Ext = item.MsgBody[0].MsgContent.Ext;
              var Sound = item.MsgBody[0].MsgContent.Sound;
              if (userId == item.From_Account) {
                item.flow = "out";
                item.from = userId;
              } else {
                item.flow = "in";
                item.from = item.From_Account;
              }

              if(item.type=="TIMTextElem"){
                  item.payload={
                      text: text
                    }
              }else if(item.type=="TIMCustomElem"){
                  item.payload={
                      data: data,
                      Desc: Desc,
                      Ext: Ext,
                      Sound: Sound
                    }
              }else if(item.type=="TIMImageElem"){
                    item.payload={
                      imageInfoArray:item.MsgBody[0].MsgContent.ImageInfoArray
                    }
                    item.payload.imageInfoArray[0].url = item.payload.imageInfoArray[0].URL
              }
              })

              datas.reverse();
              this.currentMessageList = datas
              this.$store.commit("setHisCurrentConversationID",1)
              this.$store.commit("pushCurrentMessageList", datas);
              console.info("this.currentMessageList：",this.currentMessageList)
      });
    }
  },
  mounted() {
    if(this.inquiryId){
      this.getList()
    }else{
      setTimeout(() => {
          this.getList()
      }, 2000);
    }
          


  }

};
</script>

<style lang="stylus" >
.chat_mask1 {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

#wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 100px;
}

// TODO filter mac chrome 会有问题，下次修改可以去掉
.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background: url('~@/./assets/image/bg.jpg') no-repeat 0 0;
  background-size: cover;
  // filter blur(67px)
}

.loading {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-wrapper {
  margin-top: 8vh;
  width: $width * 0.8;
  height: $height;
  max-width: 1280px;
  position: relative;

  // box-shadow: 0 11px 20px 0 rgba(0, 0, 0, 0.3);
  .chat_close_btn {
    position: absolute;
    top: 15px;
    right: 20px;
    z-index: 999;
    cursor: pointer;
  }

  .official-link {
    display: flex;
    text-decoration: none;
    color: #38c9ff;
    width: fit-content;
    float: right;
    height: 45px;
    align-items: center;
  }
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}

.current-conversation-wrapper {
  height: $height;
  background-color: $background-light;
  color: $base;
  display: flex;

  .current-conversation {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: $height;
  }

  .profile {
    height: $height;
    overflow-y: scroll;
    width: 220px;
    border-left: 1px solid $border-base;
    flex-shrink: 0;
  }

  .more {
    display: flex;
    justify-content: center;
    font-size: 12px;
  }

  .no-more {
    display: flex;
    justify-content: center;
    color: $secondary;
    font-size: 12px;
    padding: 10px 10px;
  }
}

.header {
  border-bottom: 1px solid $border-base;
  height: 50px;
  position: relative;

  .name {
    padding: 0 20px;
    color: $base;
    font-size: 18px;
    font-weight: bold;
    line-height: 50px;
    text-shadow: $font-dark 0 0 0.1em;
  }

  .btn-more-info {
    position: absolute;
    top: 10px;
    right: -15px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    cursor: pointer;

    &::before {
      position: absolute;
      right: 0;
      z-index: 0;
      content: '';
      width: 15px;
      height: 30px;
      border: 1px solid $border-base;
      border-radius: 0 100% 100% 0 / 50%;
      border-left: none;
      background-color: $background-light;
    }

    &::after {
      content: '';
      width: 8px;
      height: 8px;
      transition: transform 0.8s;
      border-top: 2px solid $secondary;
      border-right: 2px solid $secondary;
      float: right;
      position: relative;
      top: 11px;
      right: 8px;
      transform: rotate(45deg);
    }

    &.left-arrow {
      transform: rotate(180deg);

      &::before {
        background-color: $white;
      }
    }

    &:hover {
      &::after {
        border-color: $light-primary;
      }
    }
  }
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;

  .message-list {
    width: 100%;
    box-sizing: border-box;
    overflow-y: scroll;
    padding: 0 20px;
  }

  .newMessageTips {
    position: absolute;
    cursor: pointer;
    padding: 5px;
    width: 120px;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 5px;
    font-size: 12px;
    text-align: center;
    border-radius: 10px;
    border: $border-light 1px solid;
    background-color: $white;
    color: $primary;
  }
}

.footer {
  border-top: 1px solid $border-base;
  position: relative;
}

.show-more {
  text-align: right;
  padding: 10px 20px 0 0;
}

.end_mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 100%;
  padding-top: 80px;
  text-align: center;
  background-color: #e2e2e2;
  opacity: 0.2;
}

.inquiry_status_1 {
  position: absolute;
  width: 50%;
  height: 30px;
  top: 50%;
  transform: translateY(-50%);
  left: 230px;
  z-index: 999;
  font-size: 12px;
  color: #2c2c2c;
}
</style>

